import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
import { SidebarComponent } from "./sidebar/sidebar.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { FooterComponent } from "./footer/footer.component";
import { RouterModule } from "@angular/router";
import { CollapseModule } from "ngx-bootstrap/collapse";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { FormsModule } from "@angular/forms";
import { ScrollToTopComponent } from './scroll-to-top/scroll-to-top.component';
import { NavbarPublicComponent } from './navbar-public/navbar-public.component';
import { FooterPublicComponent } from './footer-public/footer-public.component';
import { ProfilePhotoModalComponent } from './profile-photo-modal/profile-photo-modal.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { ChangePasswordModalComponent } from './change-password-modal/change-password-modal.component';
import { ModalModule } from "ngx-bootstrap/modal";
import { ActionModalComponent } from './action-modal/action-modal.component';
import { AccountMerchantsComponent } from './account-merchants/account-merchants.component'; 
import { DatePipe } from "@angular/common";
import { CustomDropdownComponent } from './custom-dropdown/custom-dropdown.component';
import { OverlayModule } from '@angular/cdk/overlay';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    CollapseModule.forRoot(),
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    FormsModule,
    OverlayModule,
    ActionModalComponent
  ],
  declarations: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    ScrollToTopComponent,
    NavbarPublicComponent,
    FooterPublicComponent,
    ProfilePhotoModalComponent,
    TooltipComponent,
    ChangePasswordModalComponent,
    AccountMerchantsComponent,
    CustomDropdownComponent,
  ],
  exports: [
    FooterComponent,
    NavbarComponent,
    SidebarComponent,
    ScrollToTopComponent,
    NavbarPublicComponent,
    FooterPublicComponent,
    ProfilePhotoModalComponent,
    TooltipComponent,
    ActionModalComponent,
    CustomDropdownComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    DatePipe
  ]
})
export class ComponentsModule {}
